import { Logger, getLogger } from '@sas/nova-core/logging';

const logger: Logger = getLogger('NameUtils');

export function getEntityDisplayName(entityFullName: string, entityExtension: string | undefined) {
  return getEntityNameParts(entityFullName, entityExtension).name;
}

export function getEntityNameParts(
  entityFullName: string,
  entityExtension: string | undefined
): { name: string; extension: string | undefined } {
  if (entityExtension !== undefined && entityExtension !== '') {
    const dot: number = entityFullName.lastIndexOf(`.${entityExtension}`);
    if (dot > -1) {
      logger.debug(`removing file extension from name ${entityFullName}`);
      const parts: { name: string; extension: string | undefined } = {
        name: entityFullName.substring(0, dot),
        extension: entityFullName.substring(dot), // include dot in extension
      };
      return parts;
    }
  }
  return { name: entityFullName, extension: undefined };
}
